import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectOfflineOrdersWithFilters:
    "selectOfflineOrdersWithFilters [Action]",
  selectOfflineOrdersWithFiltersLoading:
    "selectOfflineOrdersWithFiltersLoading [Action]",
  selectOfflineOrdersWithFiltersAsync:
    "selectOfflineOrdersWithFiltersAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const selectOfflineOrdersWithFiltersReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectOfflineOrdersWithFilters:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectOfflineOrdersWithFiltersLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectOfflineOrdersWithFiltersLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "offlineorder",
    method_type: "select_offline_orders",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectOfflineOrdersWithFilters,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectOfflineOrdersWithFiltersLoading,
      payload: false,
    });
  }
}

export function* selectOfflineOrdersWithFilters() {
  yield takeLatest(
    actionTypes.selectOfflineOrdersWithFiltersAsync,
    handleWorker
  );
}
